<script>
export default {
  name: 'PageForm',
  props: ['label', 'labelSize', 'icon','text', 'formIndex', 'persistant'],
  data(){
    return{
      errors: [],
    }
  },
  computed:{
    cssLabelSize(){
      return "font-size: " + this.labelSize + "px; " + "top: -" + (this.labelSize*0.75) +"px;"
    },
  },
  methods:{
    submit(){
      let payload = [];
      let isValid = true;
      this.errors = [];

      for (const e of document.getElementById("form-body-" + this.formIndex).elements) { 
        if(e.getAttribute("required") === "required" && e.value === ""){
          this.errors.push(e.getAttribute("placeholder") + ' nécessaire');
          e.setCustomValidity("Invalid field.");
          isValid = false;
        } else {
          payload.push(e.value);
        }
      }

      if (isValid){
        if (this.persistant === undefined){
          document.getElementById("form-body-" + this.formIndex).reset();
        }
        this.$emit('submit', payload)
      }
    }
  },
}
</script>


<template>
  <div class="page-form" @submit.prevent="submit">
    <div class="page-form__title" :style="cssLabelSize"> {{label}} </div>
    <form class="form-body" :id="'form-body-' + formIndex">
      <slot name="body" :submit="submit">
        <input type="text"/>
      </slot>
      <div class="form-body__blank"></div>
      <span v-if="icon" class="material-icons icon" @click="submit"> {{icon}} </span>
      <div v-if="text" class="button validate" @click="submit"><span> {{text}} </span></div>
    </form>

    <div class="errors">
      <div v-for="error in errors" :key=error> {{error}} </div>
      <slot name="erreurs"></slot>
    </div>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

.page-form{
  @include myBackBlock;
  color: $main;
  // display: flex;
  // align-items: center;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
}

.form-body{
  width: 100%;
  margin: 10px 20px 0 0;
  display: flex;

  &__blank{
    flex: 1;
  }
}

input{
  border: none;
  border-bottom: $main solid 1px;
  // width: 100%;
  background-color: $black-lighter;
}

.button{
  cursor: pointer;
}

.icon{
  color: $main;
}

.validate{
  @include myButton;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;


  &:hover{
    @include myHover;
  }
}

.errors{
  @include myFont;
  color: $alert;
  font-size: 13px;
  margin: 10px 0 0 0;

  & *{
    margin: 2px 0 0 0;
  }
}

</style>
